// extracted by mini-css-extract-plugin
export var section = "styles-module--section--30EEu";
export var inner = "styles-module--inner--1x7dg";
export var img = "styles-module--img--Qm8xe";
export var content = "styles-module--content--3zfHt";
export var authorInfo = "styles-module--authorInfo--260kT";
export var author = "styles-module--author--3cRS4";
export var position = "styles-module--position--2oBTF";
export var button = "styles-module--button--1Zbng";